import React, { useRef, useState, useEffect } from "react";
import TicketCard from "./TicketCard";
import { motion, useScroll, useTransform, useMotionValueEvent } from "framer-motion";
import { Icon } from "@iconify/react/dist/iconify.js";
import TicketCardImg1 from "../assets/images/ticketCard1.png"
import TicketCardImg2 from "../assets/images/ticketCard2.png"
import TicketCardImg3 from "../assets/images/TicketLast.jpg"
import getYouTubeEmbedUrl from "../utils/videoUrlExtractor";

const TicketCardSection = () => {
  const stickyRef = useRef(null);
  const [scrollDirection, setScrollDirection] = useState("down");
  const ticketVideoLink = "https://youtu.be/Os6ldsKc2R0"
  const [isMobile, setIsMobile] = useState(false);

  // Check if we're on mobile on component mount and when window resizes
  useEffect(() => {
    const checkIfMobile = () => {
      // 768px is the standard breakpoint for md in Tailwind
      setIsMobile(window.innerWidth < 768);
    };

    // Initial check
    checkIfMobile();

    // Add resize listener
    window.addEventListener('resize', checkIfMobile);

    // Clean up
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);


  // Define vertical offsets for stacking cards (20% start, 15% gap)
  const start = 0.15; // Start at 20% of container height
  const gap = 0.1; // 15% gap between cards
  const yOffsets = Array.from({ length: 6 }, (_, i) => start + i * gap);

  // Track scroll progress of the sticky black div
  const { scrollYProgress, scrollY } = useScroll({
    target: stickyRef,
    offset: ["start start", "end start"], // Start at top, end when bottom reaches top
  });

  // Track scroll direction
  useMotionValueEvent(scrollY, "change", (current) => {
    const diff = current - scrollY.getPrevious();
    setScrollDirection(diff > 0 ? "down" : "up");
  });

  // Debug scrollYProgress and scrollDirection
  // useEffect(() => {
  //   scrollYProgress.onChange((value) => {
  //     console.log("scrollYProgress:", value, "scrollDirection:", scrollDirection);
  //   });
  // }, [scrollYProgress, scrollDirection]);

  // Define useTransform for each card's opacity and y at the top level
  const opacity0 = useTransform(scrollYProgress, [0, yOffsets[0], yOffsets[0]], [0, 1, 1]);
  const y0 = useTransform(scrollYProgress, [0, yOffsets[0]], [30, 0]);
  const opacity1 = useTransform(scrollYProgress, [yOffsets[0], yOffsets[1], yOffsets[1]], [0, 1, 1]);
  const y1 = useTransform(scrollYProgress, [yOffsets[0], yOffsets[1]], [10, 0]);
  const opacity2 = useTransform(scrollYProgress, [yOffsets[1], yOffsets[2], yOffsets[2]], [0, 1, 1]);
  const y2 = useTransform(scrollYProgress, [yOffsets[1], yOffsets[2]], [10, 0]);
  const opacity3 = useTransform(scrollYProgress, [yOffsets[2], yOffsets[3], yOffsets[3]], [0, 1, 1]);
  const y3 = useTransform(scrollYProgress, [yOffsets[2], yOffsets[3]], [10, 0]);
  const opacity4 = useTransform(scrollYProgress, [yOffsets[3], yOffsets[4], yOffsets[4]], [0, 1, 1]);
  const y4 = useTransform(scrollYProgress, [yOffsets[3], yOffsets[4]], [10, 0]);
  const opacity5 = useTransform(scrollYProgress, [yOffsets[4], yOffsets[5], yOffsets[5]], [0, 1, 1]);
  const y5 = useTransform(scrollYProgress, [yOffsets[4], yOffsets[5]], [0, 1]);

  // Array of transforms for easy access
  const opacities = [opacity0, opacity1, opacity2, opacity3, opacity4, opacity5];
  const ys = [y0, y1, y2, y3, y4, y5];

  const cardVariants = {
    offscreen: {
      y: 300,
      opacity: 0,
      transitionEnd: {
        display: "none", // After animation ends, hide it
      },
    },
    onscreen: {
      display: "block", // Immediately show when starting
      y: 0,
      opacity: 1,
      rotate: -5,
      transition: {
        type: "spring",
        bounce: 0.4,
        duration: 0.8,
      },
    },
  };


  const tickets = [
    {
      id: 1,
      color: "bg-card-gradient",
      leftContent: (
        <div className="text-center ">
          <img src={TicketCardImg1} alt="Vivian" className="w-36 h-36 rounded-full mx-auto mb-4 border-2 border-white shadow-lg" />
          <h3 className="text-xl font-bold text-white">Vivian</h3>
          <p>High school student</p>
        </div>
      ),
      rightContent: (
        <div className="p-4">
          <p className="text-white text-lg font-medium italic">
            With Bildup AI's guided practice and engaged learning, my maths understanding improved so much. Now i feel confident and can tackle maths problems at my grade level!
          </p>
        </div>
      )
    },

    { 
      id: 2, 
      color: "bg-card-gradient", 

      leftContent: (
        <div className="text-center">
          <img src={TicketCardImg2} alt="Lacey" className="w-36 h-36 rounded-full mx-auto mb-4 border-2 border-white shadow-lg" />
          <h3 className="text-xl font-bold text-white">Lacey</h3>
          <p>High school student</p>
        </div>
      ),
      rightContent: (
        <div className="p-4">
          <p className="text-white text-lg font-medium italic">
            "I don’t need to browse through lots of textbooks to find answers, now i can ask Bildup studybuddy anything, and it explains things in a way i truly understand"
          </p>
        </div>
      )
    },

    { 
      id: 3, 
      color: "bg-card-gradient", 

      leftContent: (
        <div className="text-center">

          <h3 className="text-[30px] font-bold text-white">Be part of the future of education</h3>

        </div>
      ),
      rightContent: (

        <div className="p-0 w-full h-full  " >
         <img src={TicketCardImg3} className=" h-full w-full scale-125 md:scale-100 "/>

        </div>
      )
    },
    // { 
    //   id: 4, 
    //   color: "bg-primary-yellow-100", 
    //   leftContent: (
    //     <div className="text-center">
    //   <img src={TicketCardImg1} alt="Vivian" className="w-36 h-36 rounded-full mx-auto mb-4 border-2 border-white shadow-lg" />
    //   <h3 className="text-xl font-bold text-white">Vivian</h3>
    //   <p>High school student</p>
    // </div>
    //   ),
    //   rightContent: (
    //     <div className="p-4">
    //       <p className="text-white text-lg font-medium italic">
    //         "Studying for exams used to be so stressful, but Bild quizzes me and explains concepts I don't understand. My test anxiety is gone!"
    //       </p>
    //     </div>
    //   )
    // },
    // { 
    //   id: 5, 
    //   color: "bg-primary-purple-400", 
    //   leftContent: (
    //    <div className="text-center">
    //   <img src={TicketCardImg1} alt="Vivian" className="w-36 h-36 rounded-full mx-auto mb-4        border-2 border-white shadow-lg" />
    //   <h3 className="text-xl font-bold text-white">Vivian</h3>
    //   <p>High school student</p>
    // </div>
    //   ),
    //   rightContent: (
    //     <div className="p-4">
    //       <p className="text-white text-lg font-medium italic">
    //         "As a teacher, Bild has transformed my classroom. It helps me create personalized learning paths for each student, and saves me hours on lesson planning."
    //       </p>
    //     </div>
    //   )
    // },
    // { 
    //   id: 6, 
    //   color: "bg-primary-blue-100", 
    //   leftContent: (
    //   <div className="text-center">
    //   <img src={TicketCardImg1} alt="Vivian" className="w-36 h-36 rounded-full mx-auto mb-4 border-2 border-white shadow-lg" />
    //   <h3 className="text-xl font-bold text-white">Vivian</h3>
    //   <p>High school student</p>
    // </div>
    //   ),
    //   rightContent: (
    //     <div className="p-4">
    //       <p className="text-white text-lg font-medium italic">
    //         "Implementing Bild across our school has improved student engagement and test scores. It's an invaluable tool for modern education."
    //       </p>
    //     </div>
    //   )
    // }
  ];

  return (
    <section className="py-8 px-4  overflow-y-clip bg-transparent" style={{ zIndex: 25 }} ref={stickyRef}>
      {/* <Overlayer/> */}
      <div className=" w-full h-full  absolute inset-0 bg-gradient-b from-transparent to-white"></div>
      <div className="max-w-screen-xl mx-auto">
     

        {/* Card Stack Section */}
        <div className="relative">
          <div

            className="relative  flex flex-col md:flex-row items-start justify-center overflow-visible"
            style={{ height: "350vh", minHeight: "100vh" }} // Sticky and tall for scrolling
          >
            <div className="sticky top-0  w-full max-w-3xl mx-auto  h-[80%]" style={{ perspective: "1200px" }}>
              {tickets.map((ticket, index) => (
                <motion.div
                  key={ticket.id}
                  className="sticky top-0 w-full"
                  style={{
                    top: `${yOffsets[index] * 70}%`, // Position at 20%, 35%, etc.
                    opacity: opacities[index], // Controlled by scroll progress
                    y: ys[index], // Controlled by scroll progress
                    rotate: isMobile ? 0 : -5 + (index * 2),

                    transformStyle: "preserve-3d",
                    willChange: "transform, opacity",
                  }}
                  variants={cardVariants}
                  transition={{
                    type: "spring",
                    bounce: 0.4,
                    duration: 0.8,
                  }}
                >
                  <div className="transform-gpu">
                    <TicketCard
                      leftContent={
                        <div className={`w-full h-full text-white ${ticket.color} rounded-xl md:p-4 p-2 flex items-center justify-center`}>
                          {ticket.leftContent}
                        </div>
                      }
                      rightContent={
                        <div className={`w-full h-full ${ticket.color} rounded-xl  flex items-center relative`}>
                          <div className="absolute left-2 md:left-3 top-2 md:top-[20%]">
                            <Icon icon={"pixel:quote-left"} className="w-6 h-6 md:w-10 md:h-10 text-white" />
                          </div>
                          <div className=" relative">
                            {ticket.rightContent}
                          </div>
                          <div className="absolute right-2 md:right-3 bottom-2 md:bottom-[25%]">
                            <Icon icon={"pixel:quote-left"} className="w-6 h-6 md:w-10 md:h-10 text-white rotate-[180deg]" />
                          </div>
                        </div>
                      }
                    />
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TicketCardSection;